import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Popover from '@material-ui/core/Popover'
import Typography from '@material-ui/core/Typography'
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
} from 'react-share'
import FileCopyOutlinedIcon from 'components/material-symbol/icons/FileCopy'
import MailOutlineIcon from 'components/material-symbol/icons/MailOutline'
import MessageOutlinedIcon from 'components/material-symbol/icons/Message'
import LinkOutlinedIcon from 'components/material-symbol/icons/Link'
import { XButton } from 'components/x-share-button/x-button'
import CopyTextButton from '../copy-text-button'
import { useStyles } from './styles'

const BookingShareActions = ({
  url,
  title,
  onCopy,
  onEmail,
  onText,
  onSocial,
}) => {
  const classes = useStyles()
  const [socialAnchorEl, setSocialAnchorEl] = useState(null)

  const handleSocialOpen = event => {
    setSocialAnchorEl(event.currentTarget)
    onSocial?.()
  }

  const handleSocialClose = () => {
    setSocialAnchorEl(null)
  }

  const handleEmailClick = () => {
    onEmail?.()
    window.location.href = `mailto:?subject=${encodeURIComponent(
      title || 'Booking Link',
    )}&body=${encodeURIComponent(url)}`
  }

  return (
    <Box className={classes.shareActionsRow}>
      <Box className={classes.shareAction}>
        <CopyTextButton
          value={url}
          component={Button}
          className={classes.shareActionButton}
          disableRipple
          onClick={onCopy}
        >
          <FileCopyOutlinedIcon
            className={classes.shareActionIcon}
            aria-hidden
          />
        </CopyTextButton>
        <Typography className={classes.shareActionLabel}>Copy link</Typography>
      </Box>

      <Box className={classes.shareAction}>
        <Button
          className={classes.shareActionButton}
          disableRipple
          onClick={handleEmailClick}
          aria-label="Email"
        >
          <MailOutlineIcon className={classes.shareActionIcon} aria-hidden />
        </Button>
        <Typography className={classes.shareActionLabel}>Email</Typography>
      </Box>

      <Box className={classes.shareAction}>
        <Button
          className={classes.shareActionButton}
          disableRipple
          onClick={onText}
          aria-label="Text"
        >
          <MessageOutlinedIcon
            className={classes.shareActionIcon}
            aria-hidden
          />
        </Button>
        <Typography className={classes.shareActionLabel}>Text</Typography>
      </Box>

      <Box className={classes.shareAction}>
        <Button
          className={classes.shareActionButton}
          disableRipple
          onClick={handleSocialOpen}
          aria-label="Social"
        >
          <LinkOutlinedIcon className={classes.shareActionIcon} aria-hidden />
        </Button>
        <Typography className={classes.shareActionLabel}>Social</Typography>
      </Box>

      <Popover
        anchorEl={socialAnchorEl}
        open={Boolean(socialAnchorEl)}
        onClose={handleSocialClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MenuList autoFocusItem onClick={handleSocialClose}>
          <MenuItem
            button
            component={FacebookShareButton}
            url={url}
            quote={title}
          >
            <ListItemIcon className={classes.menuIcon}>
              <FacebookIcon size={20} round />
            </ListItemIcon>
            <ListItemText primary="Facebook" />
          </MenuItem>
          <MenuItem
            button
            component={TwitterShareButton}
            url={url}
            title={title}
          >
            <ListItemIcon className={classes.menuIcon}>
              <XButton size={20} />
            </ListItemIcon>
            <ListItemText primary="X" />
          </MenuItem>
        </MenuList>
      </Popover>
    </Box>
  )
}

BookingShareActions.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string,
  onCopy: PropTypes.func,
  onEmail: PropTypes.func,
  onText: PropTypes.func,
  onSocial: PropTypes.func,
}

export default BookingShareActions
